import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BodyColorService {
  private bodyColor: string = 'white';

  constructor() { }

  getBodyColor(): string {
    return this.bodyColor;
  }

  setBodyColor(color: string): void {
    this.bodyColor = color;
    document.body.style.backgroundColor = color;
  }
}
